const namespace = "AUTOMATED_";

export default {
  GET_AUTOMATED_CHANNEL: `${namespace}GET_CHANNEL`,
  SET_AUTOMATED_CHANNEL: `${namespace}SET_CHANNEL`,
  GET_AUTOMATED_CHANNEL_ID: `${namespace}GET_CHANNEL_ID`,
  SET_TELEGRAM_ID: `${namespace}SET_TELEGRAM_ID`,
  CLEAR_TELEGRAM_ID: `${namespace}CLEAR_TELEGRAM_ID`,
};
